import React from 'react'
import { Col, Form, Row, Switch } from 'antd'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import { Title } from 'src/components/Ant'

import { InitialValues } from '../initial-values'

interface Props {
  formikProps: FormikProps<InitialValues>
}

export default function UserRequester({ formikProps }: Props) {
  const { t } = useTranslation()
  return (
    <>
      <Title level={4}>{t('web.user.common.assignments')}</Title>
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item
            label={t('web.table.roles.requester')}
            style={{ display: 'flex' }}
          >
            <Switch
              checked={formikProps.values.requester}
              onChange={value => {
                formikProps.setFieldValue('requester', value)
              }}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={t('web.table.roles.auditor')}
            style={{ display: 'flex' }}
          >
            <Switch
              checked={formikProps.values.auditor}
              onChange={value => {
                formikProps.setFieldValue('auditor', value)
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
